export class CcdStringUtils {

    static stringToNumber(val : string) {
        let res : number = null;
        if (val) {
          res = +val;
        }
        return res;
    }
    
    static numberToString(num : number) {
        let res : string = null;
        if (num) {
          res = num.toString();
        }
        return res;
    }

    /**
     * Conversion string --> boolean
     * @param stringVal 
     */
    static stringToBoolean(stringVal: string) {
      let result: boolean;
      if (stringVal == "true" || stringVal == "false") {
          result = (stringVal == "true");
      }
      return result;
  }

  /**
   * Indique si une string peut être interprétée en boolean
   * @param stringVal 
   */
  static isStringBoolean(stringVal : string) : boolean {
      return (stringVal == "true" || stringVal == "false");
  }
}